import { Button, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const PeCreateOrderCallCard: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <AppCard p="40px">
      <Text mb="20px" fontSize={FontSize.xl} fontWeight={700}>
        {t('makePERequest')}
      </Text>
      <Text mb="20px" fontWeight={600}>
        {t('makePERequestDescription')}
      </Text>
      <Button onClick={() => navigate(AppRoute.createPeOrder)} mr="15px">
        {t('buy')}
      </Button>
    </AppCard>
  );
};

export default PeCreateOrderCallCard;
